<template>
  <div id="Home" @scroll="handleScroll">
    <router-view />

  </div>
</template>
<script>

export default {
  components: {

  },
  watch:{
  },
  mounted(){

  },
  methods:{
    handleScroll(){
      // console.log(e.target.scrollTop)
    }
  }

};
</script>

<style lang="scss">
#home{
  width:100%;
  height:100%;
  overflow-y:scroll;
}

</style>
